import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { sagaApiGenWithPromise, } from 'utils/sagaApiGeneratorHelpers';
import { callFlowsActions } from '../actions/callFlowsActions';
import { deleteFlow, fetchFlowsFromNumbers, getQueryNumbersPage, } from '../api/callFlows';
export const { callFlowsFetchAll, callFlowsFetchAllSucceeded, callFlowsFetchAllFailed, callFlowsDelete, callFlowsDeleteSucceeded, callFlowsDeleteFailed, telephonyGetQueryNumbersPage, telephonyGetQueryNumbersPageSucceeded, telephonyGetQueryNumbersPageFailed, } = callFlowsActions;
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            result.request = action.payload;
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
function fetchAllFlowsWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            const localFlow = localStorage.getItem('unsaved_flow');
            if (localFlow) {
                const flowObject = JSON.parse(localFlow);
                flowObject.id = 'local';
                result.data.conversation_flows.unshift(flowObject);
            }
            result.request = action.payload;
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
// Saga
export const callFlows = [
    takeLatest(callFlowsFetchAll.toString(), fetchAllFlowsWithPromise(fetchFlowsFromNumbers, callFlowsFetchAllSucceeded, callFlowsFetchAllFailed)),
    takeEvery(callFlowsDelete.toString(), genWithPromise(deleteFlow, callFlowsDeleteSucceeded, callFlowsDeleteFailed)),
    takeEvery(telephonyGetQueryNumbersPage.toString(), sagaApiGenWithPromise(getQueryNumbersPage, telephonyGetQueryNumbersPageSucceeded, telephonyGetQueryNumbersPageFailed)),
];
